module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f5a1783b7dc2aeac29c16cca5c683300.png";